import { analysisEN, analysisPL, commonEN, commonPL, homeEN, homePL, veterinaroEN, veterinaroPL } from './locales';

// Partner pages only store texts that differ from the home page (arrays are replaced whole)
const withOverrides = (base, overrides) =>
  Object.fromEntries(
    Object.entries({ ...base, ...overrides }).map(([key, value]) => {
      const isObject = value && typeof value === 'object' && !Array.isArray(value);
      return [key, isObject && base[key] ? withOverrides(base[key], value) : value];
    })
  );

const resources = {
  pl: {
    common: commonPL,
    page: {
      home: homePL,
      veterinaro: withOverrides(homePL, veterinaroPL),
      analysis: analysisPL
    }
  },
  en: {
    common: commonEN,
    page: {
      home: homeEN,
      veterinaro: withOverrides(homeEN, veterinaroEN),
      analysis: analysisEN
    }
  }
};

export const languages = ['pl', 'en'];

export const initOptions = {
  resources,
  supportedLngs: languages,
  fallbackLng: 'pl',
  load: 'languageOnly',
  ns: ['common', 'page'],
  defaultNS: 'common',
  detection: {
    order: ['querystring', 'localStorage'],
    lookupQuerystring: 'lang',
    lookupLocalStorage: 'i18nextLng',
    caches: ['localStorage']
  },
  interpolation: {
    escapeValue: false
  }
};
